import { Moon } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';

export type MoonIconProps = ComponentPropsWithoutRef<typeof Moon>;

export function MoonIcon({ className, ...props }: MoonIconProps) {
  return <Moon className={cn('size-icon-sm', className)} {...props} />;
}
